// 9fbef606107a605d69c0edbcd8029e5d
import styled from 'styled-components';

export const CategoryHeader = styled.h3`
  font-family: ${(props) => props.theme.typography.fonts.secondary};
  font-size: 16px;
  font-weight: bold;
`;

export const CategoryContainer = styled.div`
  margin-bottom: 20px;
  display: flex;
  gap: 15px;
  overflow: auto;
  &::-webkit-scrollbar {
    display: none;
  }
`;

export const CategoryButton = styled.button`
  font-weight: ${(props) => (props.isActive ? 'bold' : 'normal')};
  margin: 10px 6px 0 0;
  padding: 6px 20px;
  border-radius: 6px;
  border: solid 1px #1a1a1a;
  background-color: ${(props) => (props.isActive ? '#1a1a1a' : '#ffffff')};
  font-family: ${(props) => props.theme.typography.fonts.secondary};
  font-size: 10px;
  cursor: pointer;
  color: ${(props) => (props.isActive ? '#ffffff' : '#1a1a1a')};
  text-decoration: none;
  &:hover {
    background-color: #1a1a1a;
    color: #ffffff;
  }
  transition: all 0.3s ease;
`;
